import React, { useState, useEffect } from "react";
import {
  Grid,
  Box,
  Paper,
  Typography,
  Button,
  LinearProgress,
  CircularProgress,
  Chip,
  Avatar,
  IconButton,
  Divider,
  Stack,
  Container,
  Badge,
  Card,
  CardContent,
  Collapse,
  CardMedia,
  alpha,
  CardActionArea,
  Stepper,
  Fab,
  Step,
  StepLabel,
  Tab,
  Tabs,
  useTheme,
} from "@mui/material";
import FeedbackDialog from "./FeedbackDialog";
import TocDialog from "./TocDialog";
import DownloadIcon from "@mui/icons-material/GetApp";

import Grid3x3Icon from "@mui/icons-material/Grid3x3";
import HelpDialog from "./HelpDialog";
import { useSnackbar } from "./SnackbarHandler";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";

import LightbulbIcon from "@mui/icons-material/Lightbulb";
import PrivacyTipIcon from "@mui/icons-material/PrivacyTip";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import CakeIcon from "@mui/icons-material/Cake";
import CollectionsIcon from "@mui/icons-material/Collections";
import AddIcon from "@mui/icons-material/Add";

import ImageDialog from "./ImageDialog";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { Menu, MenuItem, ListItemIcon, ListItemText } from "@mui/material";

import QuizIcon from "@mui/icons-material/Quiz";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import ThumbUpIcon from "@mui/icons-material/ThumbUpOffAlt";

import EditIcon from "@mui/icons-material/Edit";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import LessonCard from "./LessonCard";
import MoreVert from "@mui/icons-material/MoreVert";
import {
  lessonMapping,
  getLessonTypeParam,
  lessonUrlMapping,
} from "./functions";
import {
  TrendingUp,
  Download,
  Timer,
  Group,
  PlayArrow,
  EmojiEvents,
  Cake,
  AccessTime,
  Psychology,
  School,
  Image,
  VolumeUp,
  Spellcheck,
  Create,
  Collections,
  MenuBook,
  Assignment,
  CheckCircle,
  Star,
  CloudDownload,
  ArrowForward,
  Bookmark,
  BookmarkBorder,
  QuestionAnswer,
  LibraryBooks,
  RadioButtonUnchecked,
} from "@mui/icons-material";
import { db } from "./firebase";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  orderBy,
  limit,
  getDocs,
} from "firebase/firestore";

import PrintIcon from "@mui/icons-material/Print";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TeacherQuizDisplay from "./TeacherQuizDisplay";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

import { handlePrintQuiz, handlePrint1X2Quiz } from "./printFunctions";
import { handlePrintLetterLesson } from "./printFunctions";

import Logger from "./Logger";

const CurrentSection = ({ user, theme, styles }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [expandedCard, setExpandedCard] = useState(null);

  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
  const [contactDialogOpen, setContactDialogOpen] = useState(false);

  const [tocDialogOpen, setTocDialogOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [weeklyQuiz, setWeeklyQuiz] = useState(null);
  const [hoveredId, setHoveredId] = useState(null);
  const [showTeacherQuizDialog, setShowTeacherQuizDialog] = useState(false);

  const [featuredImages, setFeaturedImages] = useState([]);

  const [weeklyLesson, setWeeklyLesson] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);

  const [isExpanded, setIsExpanded] = useState(false);
  const { showSnackbar } = useSnackbar();
  const [menuPosition, setMenuPosition] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [openVideoDialog, setOpenVideoDialog] = useState(false);

  // Add this handler function with your other handlers
  const handleCardClick = (event, item, type) => {
    event.stopPropagation();
    setMenuPosition({
      top: event.clientY + 2, // Add 2px offset
      left: event.clientX + 2, // Add 2px offset
    });
    setSelectedItem({ ...item, type });
  };

  // Add this close handler
  const handleMenuClose = () => {
    setMenuPosition(null);
    setSelectedItem(null);
  };

  const [
    showTeacherQuizDialogForWeeklyExam,
    setShowTeacherQuizDialogForWeeklyExam,
  ] = useState(false);

  const [weeklyExam, setWeeklyExam] = useState(null);

  const downloadImage = async (imageUrl, filename) => {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      showSnackbar("Bild nedladdad!", "success");
    } catch (error) {
      console.error("Error downloading image:", error);
      showSnackbar("Kunde inte ladda ner bilden", "error");
    }
  };
  const handleCopyPrompt = () => {
    if (selectedImage) {
      navigator.clipboard.writeText(selectedImage?.revisedPrompt);

      showSnackbar("Prompt kopierad!", "success");
    }
  };

  useEffect(() => {
    const fetchFeaturedImages = async () => {
      try {
        const imagesRef = collection(db, "images");
        const q = query(
          imagesRef,
          where("featured", "==", true),
          orderBy("createdAt", "desc"),
          limit(6),
        );

        const querySnapshot = await getDocs(q);
        const images = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setFeaturedImages(images);
      } catch (error) {
        console.error("Error fetching featured images:", error);
      }
    };

    fetchFeaturedImages();
  }, []);

  useEffect(() => {
    const fetchWeeklyLesson = async () => {
      const lessonId = "nVAxQIjT6umFEYj9ZzbJ"; // Replace with your specific lesson ID
      const lessonDoc = await getDoc(doc(db, "lesson_usage", lessonId));
      if (lessonDoc.exists()) {
        const lessonData = { id: lessonDoc.id, ...lessonDoc.data() };
        Logger.log("weeklyLesson: ", lessonData); // Log the data directly
        setWeeklyLesson(lessonData);
      }
    };

    fetchWeeklyLesson();
  }, []);

  useEffect(() => {
    const fetchWeeklyQuiz = async () => {
      const quizId = "0pRAt74KIBbe1J5VAsKk"; // Put your specific quiz ID here
      const quizDoc = await getDoc(doc(db, "quiz", quizId));
      if (quizDoc.exists()) {
        setWeeklyQuiz({ id: quizDoc.id, ...quizDoc.data() });
      }
    };

    fetchWeeklyQuiz();
  }, []);

  useEffect(() => {
    const fetchWeeklyExam = async () => {
      const quizId = "lRvGvXOjtrOmEuxCSj3x"; // Put your specific quiz ID here
      const quizDoc = await getDoc(doc(db, "quiz", quizId));
      if (quizDoc.exists()) {
        setWeeklyExam({ id: quizDoc.id, ...quizDoc.data() });
      }
    };

    fetchWeeklyExam();
  }, []);

  const handleImageClick = (image) => {
    Logger.log("image: ", image);
    setSelectedImage(image);
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
  };

  const handleQuizUpdate = (updatedQuizData) => {
    // Update the selected quiz in state
    setWeeklyExam((prevQuiz) => ({
      ...prevQuiz,
      results: updatedQuizData,
    }));
  };

  const handleQuizUpdate2 = (updatedQuizData) => {
    // Update the selected quiz in state
    setWeeklyQuiz((prevQuiz) => ({
      ...prevQuiz,
      results: updatedQuizData,
    }));
  };

  const nationalTestContent = {
    title: "Uppladdning inför Nationella provet",
    sections: [
      {
        title: "Grammatik",
        progress: 65,
        items: [
          { type: "Quiz", count: 3, completed: 1 },
          { type: "Flashcards", count: 50, completed: 30 },
          { type: "Övningar", count: 5, completed: 2 },
        ],
      },
      {
        title: "Läsförståelse",
        progress: 45,
        items: [
          { type: "Texter", count: 4, completed: 1 },
          { type: "Övningar", count: 6, completed: 2 },
        ],
      },
      {
        title: "Hörförståelse",
        progress: 25,
        items: [
          { type: "Ljudfiler", count: 5, completed: 1 },
          { type: "Quiz", count: 5, completed: 1 },
        ],
      },
    ],
  };

  // Enhanced image package data
  const imagePackages = [
    {
      title: "Påsk Bildpaket",
      description: "5 högupplösta bilder för påsktema",
      preview: "/path/to/easter-preview.jpg",
      count: 5,
      downloads: 234,
      tags: ["Högtider", "Påsk", "Tradition"],
    },
    {
      title: "Verb i vardagen",
      description: "10 situationsbilder med vanliga verb",
      preview: "/path/to/verbs-preview.jpg",
      count: 10,
      downloads: 567,
      tags: ["Grammatik", "Verb", "Vardagssituationer"],
    },
  ];

  // Existing sample data
  const popularLesson = {
    title: "Svenska verb",
    activeUsers: 234,
    completionRate: 78,
    difficulty: "Medel",
    timeEstimate: "45 min",
  };

  const easterContent = {
    title: "Påsk Specialpaket",
    items: [
      { type: "Flashcards", count: 50 },
      { type: "Quiz", count: 3 },
      { type: "Övningar", count: 5 },
    ],
    daysLeft: 12,
  };

  // New content sections
  const newContent = {
    title: "Nytt innehåll",
    items: [
      {
        type: "Bildkort",
        desc: "Ladda hem 10 påskbilder helt grtatis",
        count: 25,
        icon: <Image />,
        color: "#E1F5FE",
        iconColor: "#0288D1",
      },
    ],
  };

  const userCreated = {
    title: "Användarskapade resurser",
    items: [
      {
        title: "Restaurang Dialog",
        author: "MariaS",
        type: "Dialogkort",
        uses: 128,
        icon: <Create />,
      },
      {
        title: "Svenska Idiom",
        author: "JohanL",
        type: "Flashcards",
        uses: 89,
        icon: <MenuBook />,
      },
    ],
  };

  return (
    <Container maxWidth="lg">
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          gap: 3,
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        <Box
          onClick={() => setOpenVideoDialog(!openVideoDialog)}
          sx={{
            ...styles.currentSectionBtn,
          }}
        >
          <PlayArrowIcon sx={{ color: "#E65100", fontSize: "1.5rem" }} />
          <Typography
            variant="h4"
            component="h2"
            align="center"
            className="typography-underline"
            sx={{
              ...styles.currentSectionBtnTypo,
            }}
          >
            Så funkar det
          </Typography>
          <ChevronRightIcon
            sx={{
              color: "#E65100",
              display: "none",
            }}
          />
        </Box>

        <Box
          onClick={() => setFeedbackDialogOpen(!feedbackDialogOpen)}
          sx={{
            ...styles.currentSectionBtn,
          }}
        >
          <LightbulbIcon sx={{ color: "#E65100", fontSize: "1.5rem" }} />
          <Typography
            variant="h4"
            component="h2"
            align="center"
            className="typography-underline"
            sx={{
              ...styles.currentSectionBtnTypo,
            }}
          >
            Föreslå funktion
          </Typography>
          <ChevronRightIcon
            sx={{
              color: "#E65100",
              display: "none",
            }}
          />
        </Box>
        <Box
          onClick={() => setTocDialogOpen(!tocDialogOpen)}
          sx={{
            ...styles.currentSectionBtn,
          }}
        >
          <PrivacyTipIcon sx={{ color: "#E65100", fontSize: "1.5rem" }} />
          <Typography
            variant="h4"
            component="h2"
            align="center"
            className="typography-underline"
            sx={{
              ...styles.currentSectionBtnTypo,
            }}
          >
            GDPR
          </Typography>
          <ChevronRightIcon
            sx={{
              color: "#E65100",
              display: "none",
            }}
          />
        </Box>

        <Box
          onClick={() => setContactDialogOpen(!contactDialogOpen)}
          sx={{
            ...styles.currentSectionBtn,
          }}
        >
          <AlternateEmailIcon sx={{ color: "#E65100", fontSize: "1.5rem" }} />
          <Typography
            variant="h4"
            component="h2"
            align="center"
            className="typography-underline"
            sx={{
              ...styles.currentSectionBtnTypo,
            }}
          >
            Kontakt
          </Typography>
          <ChevronRightIcon
            sx={{
              color: "#E65100",
              display: "none",
            }}
          />
        </Box>
        <Box
          onClick={() => setIsExpanded(!isExpanded)}
          sx={{
            ...styles.currentSectionBtn,
          }}
        >
          <EmojiEventsIcon sx={{ color: "#E65100", fontSize: "1.5rem" }} />
          <Typography
            variant="h4"
            component="h2"
            align="center"
            className="typography-underline"
            sx={{
              ...styles.currentSectionBtnTypo,
            }}
          >
            Utvalda
          </Typography>
          <KeyboardArrowDownIcon
            sx={{
              transform: isExpanded ? "rotate(180deg)" : "rotate(0)",
              transition: "transform 0.3s ease",
              color: "#E65100",
            }}
          />
        </Box>
      </Box>
      <Collapse in={isExpanded} timeout={300}>
        <Box
          sx={{
            pt: 2,
            pb: 8,
            px: 0,

            // background:
            //   "linear-gradient(180deg, rgba(0,127,255,0.08) 0%, rgba(0,89,178,0) 100%)",
            borderRadius: 4,
            position: "relative",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background:
                "radial-gradient(circle at 50% 50%, rgba(0,127,255,0.1) 0%, transparent 50%)",
              opacity: 0.5,
            },
          }}
        >
          {" "}
          <Typography
            variant="body1"
            sx={{
              color: "text.secondary",
              fontSize: "1rem",
              lineHeight: 1.7,
              fontWeight: "400",
              textAlign: "center",
              width: { xs: "100%", md: "80%" },
              margin: "0 auto",
              mb: 3,
              display: "none",
            }}
          >
            Här samlar vi utvalda lektionsmaterial som både är säsongsbetonat
            och populärt bland våra användare. Snart kommer du även ha tillgång
            till lektionspaket för nationella provet nedan. Håll ut :)
          </Typography>
          <Grid container spacing={3} sx={{ mt: 0, mb: 8 }}>
            <Grid item xs={12} md={6} sx={{ display: "none" }}>
              <Box
                sx={{
                  p: 4,
                  borderRadius: 4,
                  bgcolor: "rgba(255,255,255,0.8)",

                  backdropFilter: "blur(20px)",
                  border: "1px solid rgba(255,255,255,0.3)",
                  boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                }}
              >
                <Stack
                  direction="row"
                  justifyContent="space-between"
                  alignItems="center"
                  sx={{ mb: 4 }}
                >
                  <Typography
                    variant="h5"
                    sx={{
                      background: "linear-gradient(45deg, #FF6B6B, #845EC2)",
                      backgroundClip: "text",
                      color: "transparent",
                      fontWeight: 700,
                    }}
                  >
                    Populära lektioner just nu
                  </Typography>
                  <Box
                    sx={{
                      p: 1,
                      borderRadius: "50%",
                      bgcolor: "rgba(255,107,107,0.1)",
                    }}
                  >
                    <Cake sx={{ color: "#FF6B6B", fontSize: 32 }} />
                  </Box>
                </Stack>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "#6C757D", mb: 3, fontWeight: 500 }}
                >
                  {easterContent.daysLeft} dagar kvar
                </Typography>
                <Stack spacing={2}>
                  {easterContent.items.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        p: 2.5,
                        borderRadius: 3,
                        bgcolor: "rgba(255,255,255,0.7)",
                        backdropFilter: "blur(10px)",
                        border: "1px solid rgba(255,255,255,0.2)",
                        transition: "all 0.3s",
                        "&:hover": {
                          transform: "translateY(-2px)",
                          boxShadow: "0 5px 15px rgba(0,0,0,0.05)",
                        },
                      }}
                    >
                      <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <Stack direction="row" spacing={2} alignItems="center">
                          <Avatar
                            sx={{
                              bgcolor: "rgba(255,107,107,0.1)",
                              color: "#FF6B6B",
                            }}
                          >
                            {item.count}
                          </Avatar>
                          <Typography
                            variant="body1"
                            sx={{ color: "#2D3436", fontWeight: 500 }}
                          >
                            {item.type}
                          </Typography>
                        </Stack>
                        <IconButton
                          size="small"
                          sx={{
                            color: "#FF6B6B",
                            "&:hover": { bgcolor: "rgba(255,107,107,0.1)" },
                          }}
                        >
                          <ChevronRightIcon />
                        </IconButton>
                      </Stack>
                    </Box>
                  ))}
                </Stack>
              </Box>
            </Grid>

            {/* Keep existing Easter Special Package exactly as is */}

            <Grid item xs={12} md={6} sx={{ display: "none" }}>
              <Paper
                elevation={3}
                sx={{ p: 4, borderRadius: 4, bgcolor: "#FAFAFA" }}
              >
                <Stack
                  direction="row"
                  spacing={3}
                  alignItems="center"
                  sx={{ mb: 3 }}
                >
                  <Box sx={{ flex: 1 }}>
                    <Typography
                      variant="h5"
                      sx={{ fontWeight: 600, color: "#1A237E" }}
                    >
                      Populära påsklektioner
                    </Typography>
                    <Chip
                      label={`${easterContent.daysLeft} dagar kvar`}
                      size="small"
                      sx={{ mt: 1, bgcolor: "#E8EAF6", color: "#1A237E" }}
                    />
                  </Box>
                  <Cake sx={{ color: "#3949AB", fontSize: 48 }} />
                </Stack>
                <Stack spacing={2}>
                  {easterContent.items.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: "#F5F5F5",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Stack direction="row" spacing={2} alignItems="center">
                        <CircularProgress
                          variant="determinate"
                          value={(item.count / 10) * 100}
                          size={40}
                          sx={{ color: "#3949AB" }}
                        />
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: 500 }}
                        >
                          {item.type}
                        </Typography>
                      </Stack>
                      <IconButton color="primary" size="small">
                        <ArrowForward />
                      </IconButton>
                    </Box>
                  ))}
                  <Button variant="print"> Visa alla påsklektioner</Button>
                </Stack>
              </Paper>
            </Grid>

            {/* New Content Section */}
            <Grid item xs={12} sx={{ display: "none" }}>
              <Typography variant="h6" sx={{ mb: 2 }}>
                {newContent.title}
              </Typography>
              <Grid container spacing={2}>
                {newContent.items.map((item, index) => (
                  <Grid item xs={12} md={4} key={index}>
                    <Paper
                      sx={{
                        p: 3,
                        bgcolor: item.color,
                        height: "100%",
                      }}
                    >
                      <Stack spacing={2}>
                        <Box sx={{ color: item.iconColor }}>{item.icon}</Box>
                        <Box>
                          <Typography variant="h6" gutterBottom>
                            {item.type}
                          </Typography>
                          <Typography variant="body2" color="text.secondary">
                            {item.desc}
                          </Typography>
                        </Box>
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                        >
                          <Chip
                            label={`${item.count} kort`}
                            size="small"
                            sx={{ bgcolor: "white" }}
                          />
                          <Button
                            variant="contained"
                            size="small"
                            sx={{ bgcolor: item.iconColor }}
                          >
                            Utforska
                          </Button>
                        </Stack>
                      </Stack>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={3}>
                {weeklyLesson && (
                  <>
                    <Grid item xs={12} sm={4}>
                      <Paper
                        onClick={(e) =>
                          handleCardClick(e, weeklyLesson, "lesson")
                        }
                        sx={{
                          position: "relative",
                          p: 3,
                          pt: 4,
                          bgcolor:
                            theme.palette.mode === "dark"
                              ? "transparent"
                              : "#fff",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          cursor: "pointer",
                          borderRadius: 2,

                          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                          "&:hover": {
                            transform: "translateY(-12px)",
                          },
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "4px",
                            height: "100%",
                            background: `linear-gradient(to bottom, #E65100, transparent)`,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 1,
                          }}
                        >
                          <EmojiEventsIcon sx={{ color: "#E65100" }} />
                          <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Månadens lektion
                          </Typography>
                        </Box>
                        <IconButton
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            zIndex: 9999999,
                          }}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Box>
                          <Box
                            sx={{
                              "&:hover": {
                                filter: "brightness(1.3)", // This will darken the element by 15%
                              },
                            }}
                          >
                            <LessonCard
                              name={weeklyLesson.lessonName}
                              comment={weeklyLesson.comment}
                              timestamp={weeklyLesson.timestamp}
                              lessonType={weeklyLesson.lessonType}
                              imageUrl={weeklyLesson.coverImage}
                              size="small"
                              centered={true}
                              // onClick={() => {
                              //   const shortId = weeklyLesson.id.substring(
                              //     0,
                              //     10,
                              //   );
                              //   const typeParam = getLessonTypeParam(
                              //     weeklyLesson.lessonType,
                              //   );
                              //   const basePath =
                              //     weeklyLesson.lessonType !==
                              //     "PowerPointGenerator.js"
                              //       ? "/lektioner"
                              //       : "";
                              //   const queryString =
                              //     typeParam === "default"
                              //       ? "?v=t"
                              //       : `?type=${typeParam}&v=t`;
                              //   const url = `/app${basePath}/${lessonUrlMapping(weeklyLesson.lessonType)}/${shortId}${queryString}`;
                              //   window.open(url, "_blank");
                              // }}
                            />
                          </Box>

                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 500,
                              mb: 1,
                              color: "text.secondary",
                              mt: 2,
                              display: "none",
                            }}
                          >
                            {weeklyLesson.lessonName}
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: 400,
                              mt: 2,
                              fontSize: "0.9rem",
                              mb: 1,
                            }}
                          >
                            Du kan antingen skriva ut lektionen, eller gå in i
                            redigeringsläget, anpassa fritt och spara i ditt
                            eget arkiv.
                          </Typography>

                          <IconButton
                            size="small"
                            sx={{
                              pointerEvents: "none",
                              background: alpha("#E65100", 0.1),
                              borderRadius: "10px",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                              mt: 2,
                            }}
                          >
                            <ThumbUpIcon
                              sx={{ fontSize: "1.2rem", color: "#E65100" }}
                            />
                            <Typography
                              variant="caption"
                              sx={{
                                ml: 0.5,
                                color: "#E65100",
                                fontWeight: "600",
                                fontSize: "0.9rem",
                              }}
                            >
                              {weeklyLesson.upvotes || 0}
                            </Typography>
                          </IconButton>

                          <Box
                            sx={{
                              //display: "flex",
                              display: "none",
                              justifyContent: "space-between",
                              mt: 2,
                            }}
                          >
                            <Button
                              variant="print"
                              startIcon={<PrintIcon />}
                              onClick={() =>
                                handlePrintLetterLesson(weeklyLesson.data)
                              }
                            >
                              Skriv ut
                            </Button>
                            <Button
                              variant="print"
                              startIcon={<EditIcon />}
                              onClick={() => {
                                const shortId = weeklyLesson.id.substring(
                                  0,
                                  10,
                                );
                                const typeParam = getLessonTypeParam(
                                  weeklyLesson.lessonType,
                                );
                                const basePath =
                                  weeklyLesson.lessonType !==
                                  "PowerPointGenerator.js"
                                    ? "/lektioner"
                                    : "";
                                const queryString =
                                  typeParam === "default"
                                    ? ""
                                    : `?type=${typeParam}`;
                                const url = `/app${basePath}/${lessonUrlMapping(weeklyLesson.lessonType)}/${shortId}${queryString}`;
                                window.open(url, "_blank");
                              }}
                            >
                              Redigera
                            </Button>
                          </Box>
                        </Box>
                      </Paper>
                    </Grid>
                  </>
                )}

                {weeklyQuiz && (
                  <>
                    <Grid item xs={12} sm={4} sx={{ position: "relative" }}>
                      <Paper
                        onClick={(e) => handleCardClick(e, weeklyQuiz, "quiz")}
                        sx={{
                          position: "relative",
                          p: 3,
                          pt: 4,
                          bgcolor:
                            theme.palette.mode === "dark"
                              ? "transparent"
                              : "#fff",
                          display: "flex",
                          flexDirection: "column",
                          cursor: "pointer",
                          gap: 2,
                          borderRadius: 2,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                          "&:hover": {
                            transform: "translateY(-12px)",
                          },
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "4px",
                            height: "100%",
                            background: `linear-gradient(to bottom, #2E7D32, transparent)`,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 1,
                          }}
                        >
                          <EmojiEventsIcon sx={{ color: "#2E7D32" }} />
                          <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Månadens nutidsfrågor
                          </Typography>
                        </Box>
                        <IconButton
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            zIndex: 9999999,
                          }}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Box>
                          <Box
                            sx={{
                              "&:hover": {
                                filter: "brightness(1.3)", // This will darken the element by 15%
                              },
                            }}
                          >
                            <LessonCard
                              name={weeklyQuiz.quizName}
                              imageUrl="https://storage.googleapis.com/studeraai.appspot.com/generated-images/Z1dF5PGfjvdBGS9egzACvcSRZiN2/1738250607543.png?GoogleAccessId=firebase-adminsdk-b1cmg%40studeraai.iam.gserviceaccount.com&Expires=16730323200&Signature=U7KHVuYS8nsktmLhHxr7E9RgWSV0Ey2GZkEmD4GOxZioVatmbU5H2bIkVgoA49XIsQYgSlgb3Q0EdyWk%2Fw9CK3n%2FlaSelG3u0iBicXvGsdCZf2kZbzr5qkq%2BYTijwmxSWHW%2FJauNrh4onQd5Eg7iSen7jH5SoWGfJPChrfwl%2F%2BwPVqUFsaarWcF8qO7H3PLO3q20eieoIKTsNi7dXqqjKSxFijYcscicGsx7b0uqgKpS1MEiWgK2xVmdYzwFY%2FFKQ8abrRiORRmDwWaAjEsuwyYs0n0E56ll7cTf%2FAMVthdkgOdz9fp8rxvwQd0nKkOlI8gVSEgBqEBhWygdn6q4vg%3D%3D"
                              size="small"
                              centered={true}
                              // onClick={() =>
                              //   weeklyQuiz.questionType === "current-events"
                              //     ? handlePrint1X2Quiz(
                              //         weeklyQuiz.results,
                              //         weeklyQuiz.quizName,
                              //         weeklyQuiz.questionType,
                              //         theme.palette.primary.main,
                              //       )
                              //     : handlePrintQuiz(
                              //         weeklyQuiz.results,
                              //         weeklyQuiz.quizName,
                              //         weeklyQuiz.questionType,
                              //         theme.palette.primary.main,
                              //       )
                              // }
                            />
                          </Box>

                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 500,
                              mb: 1,
                              color: "text.secondary",
                              display: "none",
                            }}
                          >
                            {weeklyQuiz?.quizName}
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: 400,
                              mb: 1,
                              mt: 2,
                              fontSize: "0.9rem",
                            }}
                          >
                            Skriv ut månadens nutidsfrågor. Eller redigera,
                            spara i ditt eget arkiv, dela med kollegor eller
                            elever.
                          </Typography>

                          <IconButton
                            size="small"
                            sx={{
                              pointerEvents: "none",
                              background: alpha("#27792B", 0.1),
                              borderRadius: "10px",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                              mt: 2,
                            }}
                          >
                            <ThumbUpIcon
                              sx={{ fontSize: "1.2rem", color: "#27792B" }}
                            />
                            <Typography
                              variant="caption"
                              sx={{
                                ml: 0.5,
                                color: "#27792B",
                                fontWeight: "600",
                                fontSize: "0.9rem",
                              }}
                            >
                              {weeklyQuiz.upvotes || 0}
                            </Typography>
                          </IconButton>

                          <Box
                            sx={{
                              // display: "flex",
                              display: "none",
                              justifyContent: "space-between",
                              mt: 2,
                            }}
                          >
                            <Button
                              variant="print"
                              startIcon={<PrintIcon />}
                              onClick={() =>
                                weeklyQuiz.questionType === "current-events"
                                  ? handlePrint1X2Quiz(
                                      weeklyQuiz.results,
                                      weeklyQuiz.quizName,
                                      weeklyQuiz.questionType,
                                      theme.palette.primary.main,
                                    )
                                  : handlePrintQuiz(
                                      weeklyQuiz.results,
                                      weeklyQuiz.quizName,
                                      weeklyQuiz.questionType,
                                      theme.palette.primary.main,
                                    )
                              }
                            >
                              Skriv ut
                            </Button>
                            <Button
                              variant="print"
                              startIcon={<EditIcon />}
                              onClick={() => setShowTeacherQuizDialog(true)}
                            >
                              Redigera
                            </Button>
                          </Box>
                        </Box>
                      </Paper>

                      {showTeacherQuizDialog && weeklyQuiz && (
                        <TeacherQuizDisplay
                          quiz={weeklyQuiz.results}
                          selectedQuiz={weeklyQuiz}
                          quizId={weeklyQuiz.id}
                          quizName={weeklyQuiz.quizName}
                          onClose={() => setShowTeacherQuizDialog(false)}
                          onQuizUpdate={handleQuizUpdate2}
                          questionType={weeklyQuiz.questionType}
                          onPrint={() =>
                            weeklyQuiz.questionType === "current-events"
                              ? handlePrint1X2Quiz(
                                  weeklyQuiz.results,
                                  weeklyQuiz.quizName,
                                  weeklyQuiz.questionType,
                                  theme.palette.primary.main,
                                )
                              : handlePrintQuiz(
                                  weeklyQuiz.results,
                                  weeklyQuiz.quizName,
                                  weeklyQuiz.questionType,
                                  theme.palette.primary.main,
                                )
                          }
                          editMode={true}
                          styles={styles}
                          user={user}
                        />
                      )}
                    </Grid>
                  </>
                )}

                {weeklyExam && (
                  <>
                    <Grid item xs={12} sm={4} sx={{ position: "relative" }}>
                      <Paper
                        onClick={(e) => handleCardClick(e, weeklyExam, "exam")}
                        sx={{
                          cursor: "pointer",
                          position: "relative",
                          p: 3,
                          pt: 4,
                          bgcolor:
                            theme.palette.mode === "dark"
                              ? "transparent"
                              : "#fff",
                          display: "flex",
                          flexDirection: "column",
                          gap: 2,
                          borderRadius: 2,
                          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                          "&:hover": {
                            transform: "translateY(-12px)",
                          },
                          "&::before": {
                            content: '""',
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "4px",
                            height: "100%",
                            background: `linear-gradient(to bottom, #1565C0, transparent)`,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                            mb: 1,
                          }}
                        >
                          <EmojiEventsIcon sx={{ color: "#1565C0" }} />
                          <Typography variant="h6" sx={{ fontWeight: 600 }}>
                            Månadens prov/quiz
                          </Typography>
                        </Box>
                        <IconButton
                          sx={{
                            position: "absolute",
                            top: 8,
                            right: 8,
                            zIndex: 9999999,
                          }}
                        >
                          <MoreVertIcon />
                        </IconButton>
                        <Box>
                          <Box
                            sx={{
                              "&:hover": {
                                filter: "brightness(1.3)", // This will darken the element by 15%
                              },
                            }}
                          >
                            <LessonCard
                              name={weeklyExam.quizName}
                              imageUrl="https://storage.googleapis.com/studeraai.appspot.com/generated-images/x2rjH7JxWxc6GnFgPSTxGxN1bm63/1738139530773.png?GoogleAccessId=firebase-adminsdk-b1cmg%40studeraai.iam.gserviceaccount.com&Expires=16730323200&Signature=ei9l9bV%2BTNrA8vsGCrRVdMjwgYs7IdpPRnjjQzyCmrOVbJtx7pzBT8AC%2Fm4LBTc4Rw%2BwCPrWeyst6xcPawar%2BIdYcosMvNAioGIMTMbK2nbmCjtJpr73GK%2FLBnwllwIlbSmJ0bepBoRgrcTLvV%2BS1VKaySwhq7dlXcg9g7jh6eofT2kvFekmSukkB4dVItMNp9PoQiziCA0dSGDPbW%2Bahm9LBfL%2Fb4YoJxLU4sBGgAAVx2VUgoY01%2FvcTGva8LF6ckOo5nemV%2BiP1wq%2FAKPYEt4O0IJORsGGRYKWRFG%2BNJk6A0e1Xpy%2B1jpmhJrp9VADF07xzl%2Ft0P8UwIOzkq90%2BA%3D%3D"
                              size="small"
                              centered={true}
                              // onClick={() =>
                              //   weeklyExam.questionType === "current-events"
                              //     ? handlePrint1X2Quiz(
                              //         weeklyExam.results,
                              //         weeklyExam.quizName,
                              //         weeklyExam.questionType,
                              //         theme.palette.primary.main,
                              //       )
                              //     : handlePrintQuiz(
                              //         weeklyExam.results,
                              //         weeklyExam.quizName,
                              //         weeklyExam.questionType,
                              //         theme.palette.primary.main,
                              //       )
                              // }
                            />
                          </Box>
                          <Typography
                            variant="h6"
                            sx={{
                              fontWeight: 500,
                              mb: 1,
                              color: "text.secondary",
                              display: "none",
                            }}
                          >
                            {weeklyExam?.quizName}
                          </Typography>
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: 400,
                              mb: 1,
                              mt: 2,
                              fontSize: "0.9rem",
                            }}
                          >
                            Skriv ut månadens prov/quiz. Eller redigera, spara i
                            ditt eget arkiv, dela med kollegor eller elever.
                          </Typography>

                          <IconButton
                            size="small"
                            sx={{
                              pointerEvents: "none",
                              background: alpha("#1565C0", 0.1),
                              borderRadius: "10px",
                              paddingLeft: "10px",
                              paddingRight: "10px",
                              mt: 2,
                            }}
                          >
                            <ThumbUpIcon
                              sx={{ fontSize: "1.2rem", color: "#1565C0" }}
                            />
                            <Typography
                              variant="caption"
                              sx={{
                                ml: 0.5,
                                color: "#1565C0",
                                fontWeight: "600",
                                fontSize: "0.9rem",
                              }}
                            >
                              {weeklyExam.upvotes || 0}
                            </Typography>
                          </IconButton>

                          <Box
                            sx={{
                              //display: "flex",
                              display: "none",
                              justifyContent: "space-between",
                              mt: 2,
                            }}
                          >
                            <Button
                              variant="print"
                              startIcon={<PrintIcon />}
                              onClick={() =>
                                weeklyExam.questionType === "current-events"
                                  ? handlePrint1X2Quiz(
                                      weeklyExam.results,
                                      weeklyExam.quizName,
                                      weeklyExam.questionType,
                                      theme.palette.primary.main,
                                    )
                                  : handlePrintQuiz(
                                      weeklyExam.results,
                                      weeklyExam.quizName,
                                      weeklyExam.questionType,
                                      theme.palette.primary.main,
                                    )
                              }
                            >
                              Skriv ut
                            </Button>
                            <Button
                              variant="print"
                              startIcon={<EditIcon />}
                              onClick={() =>
                                setShowTeacherQuizDialogForWeeklyExam(true)
                              }
                            >
                              Redigera
                            </Button>
                          </Box>
                        </Box>
                      </Paper>

                      {showTeacherQuizDialogForWeeklyExam && weeklyExam && (
                        <TeacherQuizDisplay
                          quiz={weeklyExam.results}
                          selectedQuiz={weeklyExam}
                          quizId={weeklyExam.id}
                          quizName={weeklyExam.quizName}
                          onQuizUpdate={handleQuizUpdate}
                          onClose={() =>
                            setShowTeacherQuizDialogForWeeklyExam(false)
                          }
                          questionType={weeklyExam.questionType}
                          onPrint={() =>
                            weeklyExam.questionType === "current-events"
                              ? handlePrint1X2Quiz(
                                  weeklyExam.results,
                                  weeklyExam.quizName,
                                  weeklyExam.questionType,
                                  theme.palette.primary.main,
                                )
                              : handlePrintQuiz(
                                  weeklyExam.results,
                                  weeklyExam.quizName,
                                  weeklyExam.questionType,
                                  theme.palette.primary.main,
                                )
                          }
                          editMode={true}
                          styles={styles}
                          user={user}
                        />
                      )}
                    </Grid>
                  </>
                )}
              </Grid>
            </Grid>
            <Grid item xs={12} md={6} sx={{ mt: 3 }}>
              <Paper
                sx={{
                  position: "relative",
                  p: 3,
                  pt: 4,
                  bgcolor:
                    theme.palette.mode === "dark" ? "transparent" : "#fff",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,

                  borderRadius: 2,

                  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  "&:hover": {
                    transform: "translateY(-12px)",
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "4px",
                    height: "100%",
                    background: `linear-gradient(to bottom, #4fa7f2, transparent)`,
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  <CollectionsIcon sx={{ color: "rgb(95 176 244)" }} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Månadens bildpaket
                  </Typography>
                </Box>

                <Box>
                  <Box
                    sx={{
                      position: "relative",
                      minHeight: 335,
                      p: 2,
                      ml: 3,
                    }}
                  >
                    {featuredImages.map((image, index) => (
                      <Box
                        key={image.id}
                        sx={{
                          position: "absolute",
                          filter: "brightness(0.6)",
                          width: "165px",
                          cursor: "pointer",
                          height: "165px",
                          transform: `rotate(${Math.random() * 20 - 10}deg)`,
                          left: `${(index % 3) * 130}px`,
                          top: `${Math.floor(index / 3) * 130}px`,
                          zIndex: hoveredId === image.id ? 10 : index,
                          transition: "all 0.5s ease",
                          boxShadow: "0 4px 8px rgba(0,0,0,0.2)",
                          "&:hover": {
                            transform: "rotate(0deg) scale(1.1)",
                            zIndex: 20,
                            boxShadow: "0 8px 16px rgba(0,0,0,0.3)",
                            filter: "brightness(1)",
                          },
                        }}
                        onClick={() => handleImageClick(image)}
                      >
                        <img
                          src={image.imageUrl}
                          alt={image.prompt}
                          style={{
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            border: "4px solid white",
                          }}
                        />
                        <Box
                          sx={{
                            position: "absolute",
                            bottom: 8,
                            right: 8,
                            bgcolor: "rgba(0,0,0,0.7)",
                            borderRadius: 1,
                            px: 1,
                            py: 0.5,
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                          }}
                        >
                          <ThumbUpIcon
                            sx={{ color: "white", fontSize: "0.875rem" }}
                          />
                          <Typography
                            sx={{
                              color: "white",
                              fontSize: "0.8rem",
                              fontWeight: "500",
                            }}
                          >
                            {image.upvotes || 0}
                          </Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 2,
                    }}
                  >
                    <Button
                      variant="print"
                      startIcon={<DownloadIcon />}
                      onClick={async () => {
                        for (const image of featuredImages) {
                          try {
                            const response = await fetch(image.imageUrl);
                            const blob = await response.blob();
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement("a");
                            link.href = url;
                            link.download = `studera-ai-${image.id.substring(0, 5)}.png`;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(url);
                          } catch (error) {
                            console.error("Error downloading image:", error);
                          }
                        }
                      }}
                    >
                      Ladda ned paket (6 bilder)
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6} sx={{ mt: 3, position: "relative" }}>
              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backdropFilter: "blur(3px)",
                  //backgroundColor: "rgba(255, 255, 255, 0.1)",
                  zIndex: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "12px",
                }}
              >
                <Typography
                  variant="h6"
                  sx={{
                    color: "text.secondary",
                    fontWeight: 500,
                    textAlign: "center",

                    mt: 6,
                    padding: "8px 16px",
                    borderRadius: "8px",
                    fontSize: "1.2rem",
                    display: "none",
                  }}
                >
                  Mer spännande material kommer snart :)
                </Typography>
              </Box>
              <Paper
                sx={{
                  position: "relative",
                  p: 3,
                  pt: 4,
                  bgcolor:
                    theme.palette.mode === "dark" ? "transparent" : "#fff",
                  display: "flex",
                  flexDirection: "column",
                  gap: 2,
                  filter: "blur(6px)",
                  pointerEvents: "none",
                  borderRadius: 2,

                  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                  transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                  "&:hover": {
                    transform: "translateY(-12px)",
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "4px",
                    height: "100%",
                    background: `linear-gradient(to bottom, #4fa7f2, transparent)`,
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  <CollectionsIcon sx={{ color: "rgb(95 176 244)" }} />
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    Månadens bästa lektioner
                  </Typography>
                </Box>
                <Stack spacing={2}>
                  {easterContent.items.map((item, index) => (
                    <Box
                      key={index}
                      sx={{
                        p: 2,
                        borderRadius: 2,
                        bgcolor: "#F5F5F5",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Stack direction="row" spacing={2} alignItems="center">
                        <CircularProgress
                          variant="determinate"
                          value={(item.count / 10) * 100}
                          size={40}
                          sx={{ color: "#3949AB" }}
                        />
                        <Typography
                          variant="subtitle1"
                          sx={{ fontWeight: 500 }}
                        >
                          {item.type}
                        </Typography>
                      </Stack>
                      <IconButton color="primary" size="small">
                        <ArrowForward />
                      </IconButton>
                    </Box>
                  ))}
                  <Button variant="print"> Visa alla påsklektioner</Button>
                </Stack>
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 2,
                    }}
                  >
                    <Button
                      variant="print"
                      startIcon={<DownloadIcon />}
                      onClick={async () => {
                        for (const image of featuredImages) {
                          try {
                            const response = await fetch(image.imageUrl);
                            const blob = await response.blob();
                            const url = window.URL.createObjectURL(blob);
                            const link = document.createElement("a");
                            link.href = url;
                            link.download = `studera-ai-${image.id.substring(0, 5)}.png`;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(url);
                          } catch (error) {
                            console.error("Error downloading image:", error);
                          }
                        }
                      }}
                    >
                      Ladda ned paket (6 bilder)
                    </Button>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
          <Divider />
        </Box>
      </Collapse>
      <Menu
        open={Boolean(menuPosition)}
        onClose={handleMenuClose}
        anchorReference="anchorPosition"
        anchorPosition={menuPosition}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        PaperProps={{
          sx: {
            ...styles.roundMenu,
            ...styles.roundMenuLarger,
          },
        }}
      >
        <MenuItem
          sx={{
            ...styles.menuItemStyle,
            ...styles.menuItemStyleLarger,
          }}
          onClick={() => {
            if (selectedItem?.type === "lesson") {
              handlePrintLetterLesson(selectedItem.data);
            } else if (
              selectedItem?.type === "quiz" ||
              selectedItem?.type === "exam"
            ) {
              selectedItem.questionType === "current-events"
                ? handlePrint1X2Quiz(
                    selectedItem.results,
                    selectedItem.quizName,
                    selectedItem.questionType,
                    theme.palette.primary.main,
                  )
                : handlePrintQuiz(
                    selectedItem.results,
                    selectedItem.quizName,
                    selectedItem.questionType,
                    theme.palette.primary.main,
                  );
            }
            handleMenuClose();
          }}
        >
          <ListItemIcon sx={{ mr: 1 }}>
            <PrintIcon style={{ fontSize: "1.5rem" }} />
          </ListItemIcon>
          <ListItemText
            primary="Skriv ut"
            secondary="Snabbutskrift av materialet"
          />
        </MenuItem>
        <MenuItem
          sx={{
            ...styles.menuItemStyle,
            ...styles.menuItemStyleLarger,
          }}
          onClick={() => {
            if (selectedItem?.type === "lesson") {
              const shortId = selectedItem.id.substring(0, 10);
              const typeParam = getLessonTypeParam(selectedItem.lessonType);
              const basePath =
                selectedItem.lessonType !== "PowerPointGenerator.js"
                  ? "/lektioner"
                  : "";
              const queryString =
                typeParam === "default" ? "?v=t" : `?type=${typeParam}&v=t`;
              const url = `/app${basePath}/${lessonUrlMapping(selectedItem.lessonType)}/${shortId}${queryString}`;
              window.open(url, "_blank");
            } else if (selectedItem?.type === "quiz") {
              setShowTeacherQuizDialog(true);
            } else if (selectedItem?.type === "exam") {
              setShowTeacherQuizDialogForWeeklyExam(true);
            }
            handleMenuClose();
          }}
        >
          <ListItemIcon sx={{ mr: 1 }}>
            <EditIcon style={{ fontSize: "1.5rem" }} />
          </ListItemIcon>
          <ListItemText
            primary={
              selectedItem?.type === "lesson"
                ? "Redigera lektionen"
                : "Redigera"
            }
            secondary={
              selectedItem?.type === "lesson"
                ? "Anpassa, spara & skriv ut (ny flik)"
                : "Anpassa, spara & skriv ut"
            }
          />
        </MenuItem>
      </Menu>
      <ImageDialog
        open={dialogOpen}
        onClose={handleCloseDialog}
        selectedImage={selectedImage}
        onDownload={() => {
          if (selectedImage) {
            downloadImage(
              selectedImage.imageUrl,
              `studera-ai-${selectedImage.id.substring(0, 5)}.png`,
            );
          }
        }}
        onCopyPrompt={handleCopyPrompt}
        showSnackbar={showSnackbar}
      />
      <HelpDialog
        open={openVideoDialog}
        onClose={() => setOpenVideoDialog(false)}
        quiz={false}
        flashcards={false}
        textLabbet={false}
        grading={false}
        powerpoint={false}
        assistent={false}
        overview={true}
      />

      <FeedbackDialog
        open={contactDialogOpen}
        onClose={() => setContactDialogOpen(false)}
        user={user}
        contactForm="true"
      />

      <FeedbackDialog
        open={feedbackDialogOpen}
        onClose={() => setFeedbackDialogOpen(false)}
        user={user}
      />

      <TocDialog open={tocDialogOpen} onClose={() => setTocDialogOpen(false)} />
    </Container>
  );
};

export default CurrentSection;
